export * from './delete-rechnungs-vorlage.component';
export * from './delete-rechnungs-vorlage.component.module';